import { action } from '@ember/object';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import ContactModel from 'donor-elf-web/models/contact';
import AddSomethingModal from 'donor-elf-web/services/add-something-modal';
import ContactsCache from 'donor-elf-web/services/contacts-cache';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

interface ContactRouteParams {
  contactId: string;
}

export interface ContactRouteModel {
  contact: ContactModel;
}

export default class ContactRoute extends Route {
  @service declare addSomethingModal: AddSomethingModal;
  @service declare contactsCache: ContactsCache;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare router: RouterService;

  model(params: ContactRouteParams): ContactRouteModel {
    let contact = this.contactsCache.getById(params.contactId);
    this.navbarSettings.title = contact?.name || "Can't Find Contact";
    this.addSomethingModal.currentContactId = contact?.id;
    return {
      contact,
    };
  }

  redirect(model: ContactRouteModel) {
    if (model.contact == null) {
      this.router.transitionTo('funds.fund.contacts.contact.not-found');
    }
  }

  @action
  deactivate() {
    this.addSomethingModal.currentContactId = undefined;
  }
}
